import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppLayout from "layouts/app-layout";
import AuthLayout from 'layouts/auth-layout';
import AppLocale from "lang";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from 'antd';
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from 'configs/AppConfig';
import { db } from '../auth/FirebaseAuth';
import useBodyClass from 'hooks/useBodyClass';
import UnderMaintenance from '../underMaintenance';
import NotFound from '../404';

function RouteInterceptor({ children, isAuthenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (

          <Redirect
            to={{
              pathname: AUTH_PREFIX_PATH,
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}

export const Views = (props) => {
  const { locale, token, location, direction } = props;
  const currentAppLocale = AppLocale[locale];
  useBodyClass(`dir-${direction}`);
  // listento a document
  const [isUnderMaintenance, setIsUnderMaintenance] = useState(false);
  
  // Temporary solution for developing in maintenance mode

  useEffect(() => {
    db.collection('settings').doc('maintenance').onSnapshot((doc) => {
      if (doc.exists) {
        console.log("Maintenance:", doc.data().status);
        setIsUnderMaintenance(doc.data().status);
        if (!doc.data().status) {
          //get path from url
          const path = window.location.pathname;
          if (path === '/maintenance') {
            window.location.href = '/';
          }
        }
      }
    });
  }, []);

  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      messages={currentAppLocale.messages}>
      <ConfigProvider locale={currentAppLocale.antd} direction={direction}>
        <Switch>
          <Route path={`/404`} component={NotFound} />
          <Route path={`/maintenance`} component={UnderMaintenance} />
          {isUnderMaintenance ? <Redirect to={`/maintenance`} /> : <>
            <Route exact path="/">
            <Redirect to={APP_PREFIX_PATH} />
          </Route>
          <Route path={AUTH_PREFIX_PATH}>
            <AuthLayout direction={direction} />
          </Route>
          <RouteInterceptor path={APP_PREFIX_PATH} isAuthenticated={token}>
            <AppLayout direction={direction} location={location} />
          </RouteInterceptor>
          </>}
          <Redirect to="/404" />
        </Switch>
      </ConfigProvider>
    </IntlProvider>
  )
}


const mapStateToProps = ({ theme, auth }) => {
  const { locale, direction } = theme;
  const { token } = auth;
  return { locale, direction, token }
};

export default withRouter(connect(mapStateToProps)(Views));